const RELOAD_AT_KEY = 'ihrhelden:chunk-reload-at';
const RELOAD_COOLDOWN_MS = 60_000;
const CHUNK_ERROR_MESSAGE =
  /Failed to load chunk|Loading chunk [\w-]+ failed|Loading CSS chunk|Importing a module script failed|error loading dynamically imported module/i;

// Safari names no URL, so this message cannot be checked for a Next chunk path.
const URL_LESS_CHUNK_MESSAGE = /Importing a module script failed/i;
const NEXT_CHUNK_PATH = '/_next/static/';

let reloadPending = false;

// Vendor scripts (e.g. the TikTok pixel) throw `ChunkLoadError` for their own
// chunks too. A reload does not fix those, so only our own chunks count.
export const isChunkLoadError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) return false;
  const { name, message } = error as { name?: unknown; message?: unknown };
  if (typeof message !== 'string') return false;
  if (name !== 'ChunkLoadError' && !CHUNK_ERROR_MESSAGE.test(message)) {
    return false;
  }
  return (
    message.includes(NEXT_CHUNK_PATH) || URL_LESS_CHUNK_MESSAGE.test(message)
  );
};

export const reloadOnceForChunkError = (error: unknown): boolean => {
  if (typeof window === 'undefined' || !isChunkLoadError(error)) return false;
  try {
    const lastReloadAt = Number(
      window.sessionStorage.getItem(RELOAD_AT_KEY) ?? 0
    );
    if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) return false;
    window.sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
  } catch {
    return false;
  }
  reloadPending = true;
  window.location.reload();
  return true;
};

export const isChunkErrorAwaitingReload = (error: unknown): boolean => {
  if (typeof window === 'undefined' || !isChunkLoadError(error)) return false;
  if (reloadPending) return true;
  try {
    const lastReloadAt = Number(
      window.sessionStorage.getItem(RELOAD_AT_KEY) ?? 0
    );
    return Date.now() - lastReloadAt >= RELOAD_COOLDOWN_MS;
  } catch {
    return false;
  }
};

export const resetChunkReloadStateForTests = (): void => {
  reloadPending = false;
};
